// import { getAccountConfig } from '@src/config/serverConfig';
// import { createLogger } from '@superbet-group/web.lib.vue-utilities';

import { Logger } from '@superbet-group/web.lib.vue-utilities';

// const config = getAccountConfig();

// export const logger = createLogger({
//     dsn: config.logger.sentryDsn,
//     sampleRate: 0.01,
//     environment: config.logger.environment.name,
//     version: config.logger.environment.version,
//     isProduction: config.logger.environment.isProduction,
//     isTest: config.logger.environment.isTest,
// });

// Dummy logger until we manage to get a real one
export const logger: Logger = {
    warn: (_message: string) => {},
    info: (_message: string) => {},
    error: (_err: Error & {
        isLogged?: true;
    }) => {},
};
